<template>
	<div class="intro">
		<transition name="introfade" appear v-on:after-enter="afterTitle">
			<div :class="['content', this.step==3?'content--low':'']" v-if="step >= 3">
				<transition name="introfade-delay" appear>
					<SiteTitle/>
				</transition>
			</div>
		</transition>
		<transition name="introfade" appear v-on:after-enter="afterStars">
			<StarField v-if="step > 0 && step < 5"/>
		</transition>
		<transition name="introfade-delay" appear v-on:after-enter="afterSinger">
			<Singer v-if="step == 2"/>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import StarField from '../components/StarField'
import Singer from '../components/Singer'
import SiteTitle from '../components/SiteTitle'

export default {
	name: 'Intro',
	components: {
		SiteTitle,
		Singer,
		StarField
	},
	data () {
		return {
			step: 0
		}
	},
	methods: {
		afterStars () {
			this.step = 2
		},
		afterSinger () {
			setTimeout(() => {
				this.step = 3
			}, 1000)

		},
		afterTitle () {
			this.step = 4
			setTimeout(() => {
				this.step = 5
				localStorage.setItem('qaggiavuutIntro', true)
				setTimeout(() => {
					this.$router.push('/')
				}, 2000)
			}, 2000)
		}
	},
	created () {
		this.$emit('textures', false)
	},
	mounted () {
		this.step = 1
	},
	computed: {
		...mapGetters([])
	}

}
</script>

<style scoped lang="stylus">

.intro
	position absolute
	width 100%
	height 100%

	.content
		justify-content start
		position absolute
		min-width 100%
		left 0
		top 0
		min-height 100%
		display flex
		flex-direction column
		height 100%
		margin-top 0
		transition margin 2000ms ease-in-out

		&--low
			margin-top 25%

			/deep/ .h1
				&--en
					&:before, &:after, span
						opacity 0
						transform scale(0)

	.starfield
		transition-duration 4000ms
		&.introfade-leave-active
			transition-duration 2000ms

.singer
		transition-duration 1000ms
		&.introfade-delay-leave-active
			transition-duration 2000ms

</style>
